import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronLeftCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M2 16A14 14 0 1 0 16 2C5.6 2 2 11 2 16m16.7-6.7a1 1 0 0 1 0 1.4L13.4 16l5.3 5.3a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0l-6-6a1 1 0 0 1 0-1.4l6-6a1 1 0 0 1 1.4 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronLeftCircleFilledSVG);
ForwardRef.displayName = "IconChevronLeftCircleFilled";
export { ForwardRef as IconChevronLeftCircleFilled };
